import * as React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import SubmitModal from './SubmitModal';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

type Props = {
    submit: FlowAnyFunction;
    buttonLabel: string;
    children: React.ReactNode | React.ReactNode[];
    dialogTitle: string;
    variant?: ButtonProps['variant'];
    disabled?: boolean;
    className?: string;
    sx?: SxProps<Theme>;
};

const SubmitButton = ({
    buttonLabel,
    children,
    className = '',
    dialogTitle,
    disabled = false,
    sx = {},
    submit,
    variant = 'contained',
}: Props) => {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <Button
                variant={variant}
                onClick={() => setOpen(true)}
                className={className}
                disabled={disabled}
                sx={sx}
            >
                {buttonLabel}
            </Button>
            <SubmitModal
                submit={submit}
                dialogText={children}
                dialogTitle={dialogTitle}
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default SubmitButton;
